import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/** Uses the native variant response so inventory is computed by Shopify Liquid. */
class LumeriiaDeliveryInformation extends Component {
  #listenerController;
  #selection = 0;

  connectedCallback() {
    super.connectedCallback();
    this.#listenerController?.abort();
    this.#listenerController = new AbortController();
    this.closest('.shopify-section, dialog')?.addEventListener(
      StandardEvents.productSelect, this.#handleProductSelect,
      { signal: this.#listenerController.signal }
    );
  }

  disconnectedCallback() {
    this.#selection += 1;
    this.#listenerController?.abort();
    super.disconnectedCallback();
  }

  /** @param {ProductSelectEvent} event Native variant selection event. */
  #handleProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const selection = ++this.#selection;
    try {
      const { detail } = await event.promise;
      if (selection !== this.#selection || !this.isConnected || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = Array.from(detail.html.querySelectorAll('lumeriia-delivery-information'))
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      if (!replacement) return;
      this.dataset.productId = replacement.dataset.productId;
      morph(this, replacement, { childrenOnly: true });
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[lumeriia-delivery] Variant response failed:', error);
    }
  };
}
if (!customElements.get('lumeriia-delivery-information')) {
  customElements.define('lumeriia-delivery-information', LumeriiaDeliveryInformation);
}
